import {TextColumn, TextColumnConfig} from './text-column.model';

export class ObjectColumn extends TextColumn {
  subProperty: string;
  combineWith: string[];

  constructor(title,
              config: ObjectConfig) {
    super(title,
      {
        property: config.property,
        limit: config.limit,
      });
    this._columnType = 'ObjectColumn';
    this.subProperty = config.subProperty;
    this.combineWith = config.combineWith || [];
  }

  get(element: any): any {
    let res: string;
    if (!element[this.property]) {
      return null;
    }
    res = element[this.property][this.subProperty];

    this.combineWith.forEach(combine => {
      if (res && element[this.property][combine]) {
        res += ' ' + element[this.property][combine];
      } else {
        if (res == null) {
          res = element[this.property][combine];
        }
      }
    });

    return res;
  }
}

export interface ObjectConfig extends TextColumnConfig {
  subProperty: string;
  combineWith?: string[];
}
